import dynamic from 'next/dynamic';

export const sectionContentSwitcher = dynamic(() => import('./sectionContentSwitcher/view'));
export const sectionAddressCheckSq = dynamic(() => import('./sectionAddressCheckSq/view'));
export const sectionPlanSummary = dynamic(() => import('./sectionPlanSummary/view'));
export const sectionNbnPlanSummary = dynamic(() => import('./sectionNbnPlanSummary/view'));
export const sectionSimTypePicker = dynamic(() => import('./sectionSimTypePicker/view'));
export const sectionReferralAutoSq = dynamic(() => import('./sectionReferralAutoSq/view'));
